module.exports = __webpack_public_path__ + "static/single_mom-8eaf941d69c5247d2f664d67ff8aeaad.jpg";